import { useLocation } from 'react-router';
import { useEffect, useState } from 'react';
import { NewPageApplicationEvent } from './analyticsTypes';

export type StepAreaForAnalytics = 'root page' | 'parameters' | 'results';

interface EcondaStringParameters {
  pathName: string;
  dataType: 'applications';
  applicationName: string;
  stepArea: string;
  elementName: string;
  elementValue: string;
}

const getCurrentPage = (pathname: string): StepAreaForAnalytics => {
  const pathArray = pathname.split('/').filter(Boolean);
  if (pathArray.length === 0) return 'root page';
  if (pathArray.length === 1) return 'parameters';
  return 'results';
};

const getCurrentApplicationStep = (pathname: string) => {
  const currentStep = getCurrentPage(pathname);
  switch (currentStep) {
    case 'root page':
      return 0;
    case 'parameters':
      return 1;
    case 'results':
      return 2;
    default:
      return '404 error';
  }
};

export const generateEcondaString = ({
  pathName,
  dataType,
  applicationName,
  stepArea,
  elementName,
  elementValue,
}: EcondaStringParameters) => {
  const escapeString = (item: string): string => {
    return item.replace(/[/_]/g, '-');
  };

  const escapeElementValue = (value: string): string => {
    return value.replace(/\//g, '~');
  };

  const applicationNameEscaped = escapeString(applicationName);
  const escapedElementName = escapeString(elementName);
  const escapedElementValue = escapeElementValue(elementValue);
  const applicationStep = getCurrentApplicationStep(pathName);
  const applicationStepName = `${getCurrentPage(pathName)} page`;
  return `${dataType}/${applicationNameEscaped}/${applicationStep}/${applicationStepName}/${stepArea}/${escapedElementName}/${escapedElementValue}`.toLowerCase();
};

export const useAnalyticsHelpers = () => {
  const { pathname } = useLocation();
  const [stepArea, setStepArea] = useState<StepAreaForAnalytics>(() => getCurrentPage(pathname));
  const fwaLayer = window.fwaLayer;

  useEffect(() => {
    setStepArea(getCurrentPage(pathname));
  }, [pathname]);

  const setFWALayerPageContentIds = (contentLabel: string, stepNumber: string | number): void => {
    if (fwaLayer) {
      fwaLayer.page = fwaLayer.page || {};
      fwaLayer.page.contentLabel = `applications/shock absorber/${contentLabel}`;
      fwaLayer.page.globalContentId = `shock absorber_0000${stepNumber}`;
      const newPageEventObject: NewPageApplicationEvent = {
        eventType: 'new-page',
        newPage: {
          page: {
            contentLabel: `applications/shock absorber/${contentLabel}`,
            globalContentId: `shock absorber_0000${stepNumber}`,
            pageType: 'smart engineering page',
          },
        },
      };
      fwaLayer.send(newPageEventObject);
    }
  };

  return {
    setFWALayerPageContentIds,
    getCurrentApplicationStep,
    stepArea,
    pathname,
    getCurrentPage,
    generateEcondaString,
  };
};
